import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=fead7c4a&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=ts"
export * from "./Trades.vue?vue&type=script&lang=ts"
import style0 from "./Trades.vue?vue&type=style&index=0&id=fead7c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead7c4a",
  null
  
)

export default component.exports